import React from 'react';

import ReCAPTCHA from 'react-google-recaptcha';

import {ErrorField} from 'components/Fields';

import {GOOGLE_RECAPTCHA_CLIENT_KEY} from 'appConstants';

class RecaptchaField extends React.Component<any> {
  recaptchaRef: any = React.createRef();

  componentDidMount() {
    // When using *invisible* ReCAPTCHA, we need to call .execute() explicitly
    // Reference: https://github.com/dozoisch/react-google-recaptcha#invisible-recaptcha
    this.recaptchaRef.current.execute();
  }

  resetCaptcha() {
    this.recaptchaRef.current.reset();
  }

  render() {
    const {input: {onChange}, meta: {touched, error}} = this.props;

    return (
      <div className="RecaptchaField">
        <ReCAPTCHA
          ref={this.recaptchaRef}
          sitekey={GOOGLE_RECAPTCHA_CLIENT_KEY}
          onChange={onChange}
          onExpired={this.resetCaptcha}
          size="invisible"
        />
        <ErrorField touched={touched} error={error} />
      </div>
    );
  }
}

export default RecaptchaField;
